module.exports = __webpack_public_path__ + "static/media/bs.71e42b5a.svg";